const experienceData = [
    {
        "title": "Software Developer, Internship",
        "company": "Binghamton University, Department of Computer Science",
        "startDate": "February 2024",
        "endDate": "Present",
        "location": "Binghamton, NY, USA",
        "description": [
            "Developed a dynamic Fair Allocation and LLM Evaluation Framework using Python, generating over 10,000+ distinct allocation scenarios, evaluating LLMs like Deepseek, Gemma, and Gwen for perceived fairness.",
            "Enhanced computational throughput by 3x as measured by parallel execution benchmarks, by implementing multi-threaded valuation distribution with robust error handling and caching of subroutines.",
            "Enabled reproducible, scalable experimentation workflows as measured by 0% data loss and 100% reproducibility, by building checkpointing, structured logging, and modular interfaces across modules.",
            "Created evaluation and analysis tools for pairwise allocation comparisons, generating dynamic heatmaps and histograms for property distributions, enhancing data-driven decision-making."
        ],
        "tech": "Algorithms, LLMs, Prompt Engineering, Inter Linear Program(ILP)"
    },
    {
        "title": "Research Assistant, Iterative Voting for Committee Selection with Multi-Armed Bandits",
        "company": "Binghamton University, Department of Computer Science",
        "startDate": "January 2024",
        "endDate": "December 2024",
        "location": "Binghamton, NY, USA",
        "description": [
            "Developed a scalable iterative voting simulation framework supporting 8+ complex voting algorithms, improving system modularity by integrating Gurobi-based ILP solvers for optimal committee selection.",
            "Engineered a multi-agent simulation system that processed 50,000+ iterations per run, increasing computational efficiency by automating agent-voter interactions using epsilon-greedy Multi-Armed Bandit models.",
            "Automated performance benchmarking across voting rules, reducing manual experiment overhead by 80% through the implementation of reproducible Python pipelines and statistical analysis modules.",
            "Conducted extensive experimental analysis on preference aggregation and rule convergence, producing insights on maximizing utility and satisfaction, applicable to auction mechanisms and real-time bidding environments"
        ],
        "tech": "Reinforcement Learning, Algorithms, Interger Linear Program(ILP)"
    },
    {
        "title": "Grading Assistant",
        "company": "Binghamton University",
        "startDate": "January 2024",
        "endDate": "May 2024",
        "location": "Binghamton, NY, USA",
        "description": [
            "Graded programming assignments, projects, quizzes, and exams for 55 undergraduate and graduate students in the Machine Learning course",
            "Provided detailed and constructive feedback to students on their assignments, enhancing their understanding of machine learning concepts",
            "Collaborated with the course instructor to develop grading rubrics, ensuring consistency and fairness in evaluation"
        ],
        "tech": "Machine Learning Algorithms"
    },
    {
        "title": "Back End Developer, Internship",
        "company": "Fyle Technologies Pvt Ltd",
        "startDate": "March 2022",
        "endDate": "December 2022",
        "location": "Bangalore, India",
        "description": [
            "Developed and optimized RESTful APIs using Django, Angular, and PostgreSQL (PSQL), and collaborated with Project Managers to implement 8 new features that increased market competitiveness and user engagement.",
            "Spearheaded the implementation of a comprehensive CI/CD pipeline using Pytest and GitHub Actions, autonomously establishing automated testing for code coverage and test case validation on pull requests",
            "Independently developed unit and integration tests for 3 core modules that achieved over 98% code coverage each, significantly improving code quality, reducing crash frequency, and contributing to a 90% reduction in code review time.",
            "Authored and delivered a knowledge transfer session on Pytest, GitHub Actions, and CI principles, empowering the team to adopt robust testing and continuous integration practices.",
        ],
        "tech": "TypeScript, Python, Django, Angular, PostgreSQL, Pytest, Github Actions"
    }
];


export default experienceData